import React, { useState, useEffect } from "react";
import styles from "./RepublicaTransfer.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { postFileWithProgress, getUser } from "./constants/Requests";
import TransferSuccess from "./TransferSuccess";
import { v4 as uuidv4 } from 'uuid';
import { Tooltip } from "@mui/material";
import {addCookieTransferHistory, getCookieTransferHistory} from "./helpers/Cookies";
import { useNavigate } from "react-router-dom";
import { useStepContext } from "@mui/material";
import { checkSessionToken, deleteUserAndTokenInStorage } from './helpers/AuthHelper/AuthHelperV2';

function createId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

const expireDays = 14;

export default function RepublicaTransfer(){
 
 const navigate = useNavigate();

    const addFiles = (fileList) => {

    const selected = Array.from(fileList || []);
    if (!selected.length) return;
    
    const mapped = selected.map((file) => ({
      id: createId(),
      file,
      name: file.name,
      size: file.size,
      progress: 0,
      startedUpload: false
    }));

    setFiles((prev) => [...prev, ...mapped]);
  };

    // Fetch on component mount
    useEffect(() => {

    const fetchData = async () => {
      try {
        const user = await getUser();

        setUserEmail(user.email);
        setError(false);
        setHasError(false);

      } catch (err) {
        setError(err.message);
        setHasError(true);
      } finally {
        
      }
    };

    fetchData();
  }, []); // empty array = run once on mount


  const [files, setFiles] = useState([]);

  const [isUploading, setIsUploading] = useState(false);
  const [status, setStatus] = useState("");
  const [isError, setIsError] = useState(false);
  const [isDragging, setIsDragging] = useState(false);


  const[successGuid, setIsSuccessGuid] = useState(null);
  const[overallProgressRemaining, setOverallProgressRemaining] = useState(0);
  const[overallProgressPercentage, setOverallProgressPercentage] = useState("");

  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");

  var overallBytes = 0;
  var overallBytesTransferred = 0;
  var overallStart = null;

  const [userEmail, setUserEmail] = useState("");

  const [shipmentName, setShipmentName] = useState(null);

  const handleAddFilesClick = () => {
    document.getElementById("transfer-rt-file-input").click();
  };

  const handleFileChange = (e) => {
    addFiles(e.target.files);
    e.target.value = "";
  };

  const handleRemoveFile = (id) => {
    if (isUploading) return;
    setFiles((prev) => prev.filter((f) => f.id !== id));
  };

  const formatFileSize = (bytes) => {
    const mb = bytes / (1024 * 1024);
    return `(${mb.toFixed(1)} MB)`;
  };

function getRemainingTimeHHMMSS(startTimeMs, progressFraction) {
  if (progressFraction <= 0 || progressFraction >= 1) {
    return "00:00:00";
  }

  const now = Date.now();
  const elapsedMs = now - startTimeMs;

  // Estimate total duration from current progress
  const estimatedTotalMs = elapsedMs / progressFraction;
  let remainingMs = estimatedTotalMs - elapsedMs;

  if (remainingMs < 0) remainingMs = 0;

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours   = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}


const uploadFile = (guid, fileIndex, fileEntry, filesJson) => {
  return new Promise((resolve, reject) => {
    (async () => {

      try{

        const transferLimitPart = 25 * 1000 * 1000;

        let progress = 0;
        
        const file = files.find((f) => f.id === fileEntry.id);
        
        let offset = 0;
        let index = 0;

        let totalParts = Math.trunc((file.size / transferLimitPart) +1);

        const start = new Date().getTime();

        let overallBytesTransferredFile = overallBytesTransferred;

        while (offset < file.size) {

          var length = file.size <= transferLimitPart ? file.size : offset + transferLimitPart;

          const part = file.file.slice(offset, length);          
          const formData = new FormData();

          formData.append("file", part);
          formData.append("title", shipmentName);
          formData.append("filesCount", files.length);
          formData.append("fileIndex", fileIndex);
          formData.append("email", userEmail);
          formData.append("filesJson", filesJson);
          formData.append("partIndex", (index+1).toString());
          formData.append("totalParts", totalParts.toString());
          formData.append("fileSize", file.size.toString());
          formData.append("filename", file.name);
          formData.append("expireDays", expireDays.toString());       

          await postFileWithProgress(guid, formData, (progressEvent) => {

            const total = file.size;
            var percentCompleted = Math.round(
              ((progressEvent.loaded + offset) * 100) / total
            );           

            overallBytesTransferred = overallBytesTransferredFile + (progressEvent.loaded+offset);

            var overallProgressPercentage = Math.round(
              ((overallBytesTransferred) * 100) / overallBytes
            );

            if(overallProgressPercentage > 100){
              overallProgressPercentage = 100;
            }

            setOverallProgressPercentage(overallProgressPercentage);
            setOverallProgressRemaining(getRemainingTimeHHMMSS(overallStart, (overallBytesTransferred) /overallBytes))

            progress = percentCompleted;

            if(percentCompleted > 100){
              percentCompleted = 100;
            }

            const showRemaining = true;

            const remainingTimeFormatted = getRemainingTimeHHMMSS(start, (progressEvent.loaded + offset) /total);

            setFiles((prev) =>
              prev.map((f) =>
                f.id === fileEntry.id
                  ? {
                      ...f,
                      progress: percentCompleted,
                      remaining: showRemaining ? remainingTimeFormatted : null,
                      startedUpload: true,
                    }
                  : f
              )
            );
          });          

          offset += transferLimitPart;
          index++;
        }
        resolve();
      }
      catch(err) 
      {
        reject(err);
      }
        
    })();
  });
};

function isValidTransfername(transferName) {
  if (typeof transferName !== "string" || transferName.length === 0) {
    return false;
  }

  // 1. Invalid characters (windows filename illegal chars)
  const invalidChars = /[\\\/:*?"<>|]/;
  if (invalidChars.test(transferName)) {
    return false;
  }
  return true;
}


  const handleSubmit = async (e) => {

    setIsError(false);

    e.preventDefault();

    if(!userEmail.toLowerCase().includes("@republica.dk")){
      setStatus(true ? "Please enter a @republica email." : "");
      setIsError(true);
      return;
    }

    if(!isValidTransfername(shipmentName))
    { 
      setStatus("Name contains one or more invalid characters: /[\\\/:*?\"<>|]/");
      setIsError(true);
      return;
    }

    if (!files.length || isUploading) {
      setStatus(!files.length ? "Please select at least one file." : "");
      setIsError(true);
      return;
    }

    setIsUploading(true);
    setStatus("Uploading files...");

    const guid = uuidv4();

    var currentFile = 0;

    const json = JSON.stringify(
      files.map(f => ({
        name: f.name,
        length: f.size
      })),
    );

    try{

      overallBytes = 0;

      setOverallProgressPercentage(overallBytes);
      setOverallProgressRemaining("0");

      for (const file of files) {
        overallBytes += file.size;
      }     

      overallStart = new Date().getTime();

      for (const entry of files) {
        await uploadFile(guid, currentFile, entry, json);
        currentFile++;
      }

      addCookieTransferHistory(guid, 7);
      setIsError(false);
      setIsSuccessGuid(guid);
    }
    catch{
      setStatus("An error occured during upload.");
      setIsError(true);
      setIsUploading(false);
    };
  };

  // Drag & drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Only reset if leaving the drop zone itself
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isUploading) return;

    const dtFiles = e.dataTransfer?.files;
    if (dtFiles && dtFiles.length) {
      addFiles(dtFiles);
    }
    setIsDragging(false);
  };

if(hasError){
  return (<div>Der er sket en fejl, kontakt mbsupport@republica.dk med følgende information: {error}</div>)
}

  if(successGuid)
    return <TransferSuccess shipmentId={successGuid} shipmentName={shipmentName}/>

/*
            <span>Republica</span>
            <span className="transfer-rt-arrow">⇄</span>
            <span>Transfer</span>*/

  return (

      <div
        className={`transfer-rt-body ${isDragging ? "transfer-rt-body--dragging" : ""}`}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          backgroundImage: 'url("/assets/background.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
      >
        <a href="/">
          <img src="assets/RepublicaTransfer-logo.png" disabled={isUploading} class="republica-logo"
          />
        </a>
      <div/>

      <div className="transfer-rt-page">
        <header className="transfer-rt-header">
          <div className="transfer-rt-brand">
          </div>
            <div className="logout-btn" onClick={()=>{console.log("logout");deleteUserAndTokenInStorage();window.location.reload()}}>Log out</div>
          <button disabled={isUploading} className="history-btn" type="button" onClick={() =>{navigate("/history")}}>
            Transfer history
          </button>
        </header>

        <main className="transfer-rt-content">
          <section className="transfer-rt-cards">
            {/* LEFT CARD: FILES */}
            <div className="transfer-rt-card" id="transfer-rt-file-card">
              <h2 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}><span>Selected files: {files.length}</span> 
              <Tooltip 
                title={
                  <div>
                    {files.map(f => (
                  <div key={f.name}>{f.name}</div>
                ))}
                  </div>
                }
              >
                <span style={{ cursor: "pointer" }}>{files.length <= 0 ?  "" : "?"}</span>
              </Tooltip>
              </h2>

              <div
                className={`transfer-rt-drop-zone ${
                  isDragging ? "transfer-rt-drop-zone--active" : ""
                }`}

              >
                <div className="transfer-rt-file-list" id="transfer-rt-file-list">
                  {!files.length && (
                    <p className="transfer-rt-muted">
                      Drop files anywhere, or click the button below.
                    </p>
                  )}

                  {files.map((entry) => (
                    <div className="transfer-rt-file-item" key={entry.id}>
                      <div className="transfer-rt-file-header">
                        <div className="transfer-rt-file-name-size">
                          <div className="transfer-rt-file-name">
                            {entry.file.name}
                          </div>
                          <div className="transfer-rt-file-size">
                            {formatFileSize(entry.file.size)}
                          </div>
                        </div>

                        <button
                          type="button"
                          className="transfer-rt-remove-btn"
                          onClick={() => handleRemoveFile(entry.id)}
                          disabled={isUploading}
                        >
                          &times;
                        </button>
                      </div>
                      {entry.startedUpload && (
                        <div>
                          <div className="transfer-rt-progress-wrapper">
                            <div
                              className="transfer-rt-progress-bar"
                              style={{ width: `${entry.progress}%` }}
                            />
                          </div>
                          <div className="transfer-rt-progress-text">
                            {entry.progress ? (`${entry.progress}%${entry.remaining ? (" (" +  entry.remaining+")") : ""}`) : "0%"}
                          </div>
                        </div>
                      )
                      }
                    </div>
                  ))}
                </div>

                
              </div>
              <button
                  className="transfer-rt-btn-secondary"
                  type="button"
                  id="transfer-rt-add-files-btn"
                  onClick={handleAddFilesClick}
                  disabled={isUploading}
                  style={{marginTop: "14px", marginBottom:"22px"}} /* style override to align tilføj and send filer buttons */
                >
                  Add files
                </button>

                <input
                  type="file"
                  id="transfer-rt-file-input"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
            </div>

            {/* RIGHT CARD: FORM */}
            <div className="transfer-rt-card">
              <h2>Your e-mail</h2>

              <form id="transfer-rt-transfer-form" onSubmit={handleSubmit}>
                <div className="transfer-rt-form-group">
                  <input
                    disabled={true}
                    id="transfer-rt-email-input"
                    type="email"
                    className="transfer-rt-form-input"
                    placeholder="enter a republica email"
                    required
                    onChange={(e) =>  setUserEmail(e.target.value)}
                    value={userEmail}
                  />
                </div>

                <div className="transfer-rt-form-group transfer-rt-form-name-group">
                  <h2 className="transfer-rt-form-label" htmlFor="transfer-rt-shipment-name">
                    Name of transfer
                  </h2>
                  <input
                    disabled={isUploading}
                    id="transfer-rt-shipment-name"
                    type="text"
                    className="transfer-rt-form-input"
                    placeholder="enter name"
                    onChange={(e) => setShipmentName(e.target.value) }
                    maxLength={50}
                    required
                  />
                </div>
                {isUploading &&
                  <div className="transfer-rt-progress-parent">
                    <br></br>
                    <label>Total progress</label>
                    <div className="transfer-rt-progress-wrapper">
                      { <div
                        className="transfer-rt-progress-bar"
                        style={{ width: `${overallProgressPercentage}%` }}
                      />}
                    </div>
                    <div className="transfer-rt-progress-text">
                      {overallProgressPercentage}% {overallProgressRemaining}
                    </div>
                  </div>
                }
                <button
                  className="transfer-rt-btn-primary"
                  type="submit"
                  id="transfer-rt-send-btn"
                  disabled={isUploading}
                  style={!isUploading ? {marginTop: "auto"} : undefined}
                >
                  Send files
                </button>
                {isError ?
                    <div className="transfer-rt-status-error" id="transfer-rt-status-error">
                        {status}
                    </div>
                :
                    <div className="transfer-rt-status-text" id="transfer-rt-status-text">
                        {status}
                    </div>
                }

                
              </form>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};
